// src/App.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import QueryHistory from './components/QueryHistory/QueryHistory';
import QueryDetails from './components/services/AILegalResearcher/QueryDetails/QueryDetails';
import TransactionHistory from './components/TransactionHistory/TransactionHistory';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/Auth/PrivateRoute';

// Add CSS for global animations
import './index.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          
          <Route
            path="/history"
            element={
              <PrivateRoute>
                <QueryHistory />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/history/query/:questionId"
            element={
              <PrivateRoute>
                <QueryDetails />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/transactions"
            element={
              <PrivateRoute>
                <TransactionHistory />
              </PrivateRoute>
            }
          />

          {/* 404 Route - Redirect to Dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;